import styled from 'styled-components';

export const TodayButtonWrapper = styled.div`
  margin-right: 8px;
`;
